import { Box, Button, Typography, Link } from "@mui/material";
import ManageClubImg from "../../assets/images/Home/ManageClubImg.png";
import ManageClubBG from "../../assets/images/Home/ManageClubBG.png";
import { AndroidIcon, AppleIcon, ListCheckIcon } from "../../assets/icons/MUI/HomeIcons";
import { useTranslation } from "react-i18next";

const ManageClubSection = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        width: "95%",
        maxWidth: "1240px",
        margin: "0 auto",
        padding: {
          xs: "60px 0",
          lg: "94px 0 ",
        },
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: `url(${ManageClubBG})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        gap: "32px",
        flexDirection: {
          xs: "column",
          lg: "row",
        },
      }}
    >
      <img
        src={ManageClubImg}
        style={{
          maxWidth: "100%",
          width: "576px",
          height: "auto",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: {
            xs: "24px",
            lg: "33px",
          },
          maxWidth: "605px",
        }}
      >
        <Typography
          component="h2"
          sx={{
            color: "#FFF",
            fontFamily: "Montserrat",
            fontStyle: "normal",
            fontWeight: 750,
            lineHeight: "130%",
            textTransform: "uppercase",
            fontSize: {
              xs: "30px",
              lg: "40px",
            },
          }}
        >
          {t("pages.home.manageYourClub")}
        </Typography>
        <Typography
          component="p"
          sx={{
            color: "#FFF",
            fontFamily: "Montserrat",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "24px",
          }}
        >
          {t("pages.home.goalngoApp")}
        </Typography>
        <Box component="ul" sx={{ display: "flex", flexDirection: "column", rowGap: "14px" }}>
          <Box
            component="li"
            sx={{
              display: "flex",
              columnGap: "14px",
              alignItems: "center",
            }}
          >
            <ListCheckIcon />
            <Typography
              sx={{
                color: "var(--White, #FFF)",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "18px",
              }}
            >
              {t("pages.home.postUpdates")}
            </Typography>
          </Box>
          <Box
            component="li"
            sx={{
              display: "flex",
              columnGap: "14px",
              alignItems: "center",
            }}
          >
            <ListCheckIcon />
            <Typography
              sx={{
                color: "var(--White, #FFF)",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "18px",
              }}
            >
              {t("pages.home.engageCommunity")}
            </Typography>
          </Box>
          <Box
            component="li"
            sx={{
              display: "flex",
              columnGap: "14px",
              alignItems: "center",
            }}
          >
            <ListCheckIcon />
            <Typography
              sx={{
                color: "var(--White, #FFF)",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "18px",
              }}
            >
              {t("pages.home.arrangeMatches")}
            </Typography>
          </Box>
          <Box
            component="li"
            sx={{
              display: "flex",
              columnGap: "14px",
              alignItems: "center",
            }}
          >
            <ListCheckIcon />
            <Typography
              sx={{
                color: "var(--White, #FFF)",
                fontFamily: "Montserrat",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "18px",
              }}
            >
              {t("pages.home.findTalents")}
            </Typography>
          </Box>
        </Box>
        <Typography
          component="h5"
          sx={{
            color: "#FFF",
            fontFamily: "Montserrat",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 750,
            lineHeight: "27px",
          }}
        >
          {t("pages.home.downloadNow")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            columnGap: "18px",
            justifyContent: {
              xs: "center",
              sm: "flex-start",
            },
          }}
        >
          <Link
            href="https://play.google.com/store/apps/details?id=com.goalngo_tech.goalngo&hl=en&pli=1"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{
              color: "unset",
            }}
          >
            <Button sx={{ background: "none !important", border: "none !important", color: "unset" }}>
              <AndroidIcon />
            </Button>
          </Link>
          <Link
            href="https://apps.apple.com/us/app/goalngo/id6443919098"
            target="_blank"
            rel="noopener noreferrer"
            underline="none"
            sx={{
              color: "unset",
            }}
          >
            <Button sx={{ background: "none !important", border: "none !important", color: "unset" }}>
              <AppleIcon />
            </Button>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default ManageClubSection;
